import {
  GET_CLIENT_CAMPAIGN_FULFILLMENT,
  GET_CLIENT_CAMPAIGN_FULFILLMENT_ERROR,
  GET_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS,
  EXPORT_CLIENT_CAMPAIGN_FULFILLMENT,
  EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS,
  EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_ERROR,
} from "./actionTypes"

export const getClientCampaignFulfillment = (payload, paginated = false) => {
  return {
    type: GET_CLIENT_CAMPAIGN_FULFILLMENT,
    payload: payload,
    paginated,
  }
}

export const getClientCampaignFulfillmentSuccess = (payload, meta = {}) => {
  return {
    type: GET_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS,
    payload: payload,
    meta,
  }
}

export const getClientCampaignFulfillmentError = error => {
  return {
    type: GET_CLIENT_CAMPAIGN_FULFILLMENT_ERROR,
    payload: error,
  }
}

export const exportClientCampaignFulfillment = (payload) => {
  return {
    type: EXPORT_CLIENT_CAMPAIGN_FULFILLMENT,
    payload: payload,
  }
}

export const exportClientCampaignFulfillmentSuccess = (response) => {
  return {
    type: EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_SUCCESS,
    payload: response,
  }
}

export const exportClientCampaignFulfillmentError = (error) => {
  return {
    type: EXPORT_CLIENT_CAMPAIGN_FULFILLMENT_ERROR,
    payload: error,
  }
}
